export const CURRENT_SEASON = "P27";

// Colori della distinta base con materiali non ancora scelti
export const bomGaps = (tech = {}) => {
  const rows = [
    ...(tech.fabrics || []).filter((f) => (f.fabric_type || "").trim()).map((f) => [f.fabric_type, f.by_color]),
    ...(tech.accessories || []).filter((a) => (a.name || "").trim()).map((a) => [a.name, a.by_color]),
  ];
  return (tech.colors || []).map((c) => ({ color: c, missing: rows.filter(([, bc]) => !bc?.[c]).map(([n]) => n) })).filter((g) => g.missing.length);
};
